(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-darich"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const cartDrawer = document.getElementById('cart-drawer');
    const cartTriggers = document.querySelectorAll('[href="/cart"]');
    const closeBtn = cartDrawer.querySelector('.darich-cart-drawer__close');
    const overlay = cartDrawer.querySelector('.darich-cart-drawer__overlay');

    // Open cart drawer
    cartTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        cartDrawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    });

    // Close cart drawer
    function closeCart() {
      cartDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeCart);
    }

    if (overlay) {
      overlay.addEventListener('click', closeCart);
    }

    // Quantity controls
    const qtyButtons = cartDrawer.querySelectorAll('.darich-qty-btn');
    qtyButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        const action = this.dataset.action;
        const line = this.dataset.line;
        const input = cartDrawer.querySelector(`.darich-qty-input[data-line="${line}"]`);
        let qty = parseInt(input.value);

        if (action === 'increase') {
          qty++;
        } else if (action === 'decrease' && qty > 0) {
          qty--;
        }

        input.value = qty;
        updateCart(line, qty);
      });
    });

    // Remove items
    const removeButtons = cartDrawer.querySelectorAll('.darich-cart-item__remove');
    removeButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        const line = this.dataset.line;
        updateCart(line, 0);
      });
    });

    // Update cart via AJAX
    function updateCart(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
      .then(response => response.json())
      .then(data => {
        location.reload(); // Reload to update cart
      })
      .catch(error => console.error('Error:', error));
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-overlay-darich"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const searchOverlay = document.getElementById('search-overlay');
    const searchTriggers = document.querySelectorAll('.darich-header__icon[aria-label="Search"]');
    const closeBtn = searchOverlay.querySelector('.darich-search-overlay__close');
    const backdrop = searchOverlay.querySelector('.darich-search-overlay__backdrop');
    const searchInput = document.getElementById('search-input');
    const resultsContainer = document.getElementById('search-results');

    // Open search overlay
    searchTriggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        searchOverlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        setTimeout(() => searchInput.focus(), 300);
      });
    });

    // Close search overlay
    function closeSearch() {
      searchOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
      searchInput.value = '';
      resultsContainer.innerHTML = '';
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeSearch);
    }

    if (backdrop) {
      backdrop.addEventListener('click', closeSearch);
    }

    // Predictive search
    let searchTimeout;
    if (searchInput) {
      searchInput.addEventListener('input', function() {
        clearTimeout(searchTimeout);
        const query = this.value.trim();

        if (query.length < 2) {
          resultsContainer.innerHTML = '';
          return;
        }

        searchTimeout = setTimeout(() => {
          fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`)
            .then(response => response.json())
            .then(data => {
              displayResults(data.resources.results.products);
            })
            .catch(error => console.error('Search error:', error));
        }, 300);
      });
    }

    function displayResults(products) {
      if (!products || products.length === 0) {
        resultsContainer.innerHTML = '<div class="darich-search-overlay__empty">検索結果が見つかりませんでした</div>';
        return;
      }

      const html = products.map(product => `
        <a href="${product.url}" class="darich-search-result">
          <div class="darich-search-result__image">
            ${product.featured_image ? 
              `<img src="${product.featured_image}" alt="${product.title}" loading="lazy">` : 
              ''}
          </div>
          <div class="darich-search-result__info">
            <h3 class="darich-search-result__title">${product.title}</h3>
            <div class="darich-search-result__price">¥${(product.price / 100).toLocaleString()}</div>
          </div>
        </a>
      `).join('');

      resultsContainer.innerHTML = html;
    }

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchOverlay.classList.contains('is-open')) {
        closeSearch();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
